import { ThunkDispatch } from 'redux-thunk'
import { connect } from 'react-redux'
import { AnyAction } from 'redux'

import { IDisplayDispatchProps } from './types'
import { IStateProps } from '../types'
import { fetchInstallations, deleteInstallation } from '../../../../store/installations/actions'
import { IState } from '../../../../store/types'
import { IInstallation } from '../../../../types/installation'
import { Display } from './Display'

const mapStateToProps = (state: IState): IStateProps => {
  return {
    installations: state.installations,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IDisplayDispatchProps => {
  return {
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },
    deleteInstallation: (installation: IInstallation) => {
      return dispatch(deleteInstallation(installation))
    }
  }
}

const DisplayContainer = connect(mapStateToProps, mapDispatchToProps)(Display)

export {
  DisplayContainer
}
